import { render, staticRenderFns } from "./ResetPasswordView.vue?vue&type=template&id=6ae4c766"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports